import React from 'react';
import { SLogo, STitle } from '../styles/Header.styled';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/pro-solid-svg-icons';
import { SArrowLeftIcon } from '../styles/Form.styled';
import { LoginRoute } from '../../../common/routes';
import { useNavigate } from 'react-router-dom';

const Header: React.FC = () => {
  const navigate = useNavigate();

  return (
    <>
      <SLogo>
        <img
          src={`${process.env.PUBLIC_URL}/assets/images/billComposerCyan.svg `}
          height="80px"
          alt="CSG logo"
          id="imgBcLogo"
        />
      </SLogo>
      <SArrowLeftIcon onClick={() => navigate(`/${(window as any).CSG_CONFIG.BASE_PATH}/${LoginRoute}`)}>
        <FontAwesomeIcon id="lnkBackToLogin" icon={faArrowLeft} title="Back to Login" />
      </SArrowLeftIcon>
      <STitle>
        <span id="idForgotYour">Forgot your</span>
        <span id="idPassword">Password?</span>
      </STitle>
    </>
  );
};

export default Header;
